import { Rocket, ShieldCheck, Zap, Users, Trophy } from 'lucide-react';
import type { EarnCategoryShell, RewardsNavItem } from './rewardsPageTypes';
import { SKILL_TEST_EXPIRY_BUSINESS_DAYS } from '../../ContestSkillTest/skillTestUtils';

export const EARN_CATEGORY_SHELL: EarnCategoryShell = {
  'Welcome & Onboarding': { Icon: Rocket, accent: '#1BA97B', bg: '#EDFAF5' },
  'Financial Health & Punctuality': { Icon: ShieldCheck, accent: '#0055FF', bg: '#EEF5FF' },
  'Engagement & Stickiness': { Icon: Zap, accent: '#7C3AED', bg: '#F3EEFF' },
  'Community & Social': { Icon: Users, accent: '#E85D75', bg: '#FFF0F3' },
  'Milestones & Seasonal': { Icon: Trophy, accent: '#D39A1C', bg: '#FFF6E6' },
};

export const REWARDS_NAV_ITEMS: readonly RewardsNavItem[] = [
  { id: 'earn', label: 'How to earn', href: '/rewards' },
  { id: 'referrals', label: 'Referrals', href: '/rewards/referrals' },
  { id: 'social', label: 'Social Submissions', href: '/rewards/social-submissions' },
] as const;

export const CONTEST_RULES: readonly string[] = [
  'Contest runs from the 1st to the last day of each month.',
  'Only qualified rent payments made through TenantPay are counted.',
  'Any suspicious activity can result in disqualification.',
  'In case of a tie, the earliest qualifying transaction wins.',
  'Winners are announced after month-end verification.',
  `Winners have ${SKILL_TEST_EXPIRY_BUSINESS_DAYS} business days to complete the skill-testing question.`,
] as const;

